import { httpCreate } from './http';
import { createNamespacedHelpers } from 'vuex';

const http = httpCreate('/srv/conditional-lottery');

export const conditionalLottery = {
	//获取直播抽奖列表
	getLotteryList(id, params) {
		return http.get(`/${id}`, { params });
	},
	//删除抽奖
	delete(id) {
		return http.delete(`/${id}`);
	},
	//参与抽奖
	attend(id) {
		return http.post(`${id}/takePartInlottery`);
	},
	//修改抽奖
	changeLottery(data) {
		return http.put('', data);
	},
	//新建抽奖
	addLottery(data) {
		return http.post('', data);
	},
	// 首次开奖
	manualLottery(id) {
		return http.post(`${id}/manualLottery`);
	},
	//批量删除参与记录
	batchDelete(activityId, data) {
		return http.post(`/batchDelete/${activityId}`, data);
	},
	// 删除中奖名单
	deleteWinUser(activityId, data) {
		return http.post(`/${activityId}/deleteWinUser`, data);
	},
	//获取抽奖参与名单
	getPartake(lotteryId, data, params) {
		return http.get(`/${lotteryId}/participations`, data, { params });
	},
	//导出参与名单
	exportPartake(lotteryId, params) {
		return http.get(`/${lotteryId}/exportExcel`, { params });
	},
	//标记为可以中奖/不可以中奖
	markWinStatus(id, params) {
		return http.post(`/${id}/changeCanWin`, {}, { params });
	},
	// 获取必中奖人员名单
	mustWinUsers(lotteryId) {
		return http.get(`/${lotteryId}/mustWinUsers`);
	},
	// 批量标记可以中奖
	changeCanWin(lotteryId, data) {
		return http.post(`/changeCanWin/${lotteryId}`, data);
	},
	blackList(lotteryId, params) {
		return http.get(`/blackList/${lotteryId}`, { params: params });
	},
	addBlack(lotteryId, phone) {
		return http.post(`/addBlack/${lotteryId}`, { mobPhone: phone });
	},
	batch(lotteryId, phones) {
		return http.delete(`/batch/${lotteryId}`, { data: phones });
	},
	upload(lotteryId, file) {
		return http.post(`/importBlack/${lotteryId}`, file);
	},
	virtually(lotteryId, num) {
		return http.post(`/virtually/${lotteryId}/${num}`);
	},
	getVirtually(lotteryId) {
		return http.get(`/virtually/${lotteryId}`);
	},
};
